import useExtractObservationEntry from "./useExtractObservationEntry";

export const useExtractObservationEntryValue = (
	diaryId: string,
	observationId: string,
	entryId: string,
	entryValueId: string,
) => {
	const entry = useExtractObservationEntry(diaryId, observationId, entryId);
	if (!entry) return;
	return entry.entry_values?.find((evv) => evv.entry_value_id === entryValueId);
};
